<template>
  <div class="feed-item-display col-12">
    <div class="card card-default mb-4" :style="{borderWidth: '2px', borderColor: feedItem.Action.color}">
      <div class="card-body media">
        <!-- <img :src="icon" :alt="feedItem.reportType" class="img-thumbnail float-left"> -->
        
        <i :class="icon" :style="{marginRight: '1.25rem'}"></i>
        
        <div class="media-body">
          <p>
            <span class="text-muted small"><i class="far fa-clock fa-fw"></i> {{ feedItem.createdAt | date_time_format }}</span><br/>
            <!-- {{{ feedItem.Action.logOutput }}} -->
            <strong>{{ feedItem.ActionTaker.dropdownLabel }}</strong> {{ feedItem.Action.verb }} {{ article }} {{ feedItem.Action.actionPerformedOn }}
            <template v-if="options.inDetail">
              <template v-if="feedItem.Quote && feedItem.ActionPerformedOn">
                <br/> Action performed on quote <strong>{{ feedItem.Quote.reference }}</strong> and user <strong>{{ feedItem.ActionPerformedOn.dropdownLabel }}</strong>
              </template>
              <template v-else-if="feedItem.Quote">
                <br/> Action performed on quote <strong>{{ feedItem.Quote.reference }}</strong>
              </template>
              <template v-else-if="feedItem.ActionPerformedOn">
                <br/> Action performed on {{ feedItem.Action.actionPerformedOn }} <strong>{{ feedItem.ActionPerformedOn.dropdownLabel }}</strong>
              </template>
            </template>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LiveFeed',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      },
      options: {
        type: Object,
        default () {
          return {
            inDetail: true,
            iconSize: '4x'
          }
        }
      }
    },
    computed: {
      article () {
        if (['a', 'e', 'i', 'o', 'u'].includes(this.feedItem.Action.actionPerformedOn.toLowerCase().charAt(0))) {
          return 'an'
        }
        return 'a'
      },
      icon () {
        return 'fa-fw fa-' + this.options.iconSize + ' ' + this.feedItem.Action.icon
      },
      feedItem () {
        return {
          Application: {
            AppIcon: {}
          },
          ...this.object
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cards/LiveFeed.vue